import { render, staticRenderFns } from "./InviteFriendsNotice.vue?vue&type=template&id=0b26b400&scoped=true"
import script from "./InviteFriendsNotice.vue?vue&type=script&lang=js"
export * from "./InviteFriendsNotice.vue?vue&type=script&lang=js"
import style0 from "./InviteFriendsNotice.vue?vue&type=style&index=0&id=0b26b400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b26b400",
  null
  
)

export default component.exports